var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Header } from "semantic-ui-react";
import { ORIGIN } from "../Config";
import proteinLogo from '../images/logo_Protein.png';
import rnaLogo from '../images/logo_RNA.png';
import KitDisplay from "../kit/rna-fish/KitDisplay";
import { BundleOfKits, Ihc2Kit, RnaFishKit } from "./rna-fish/KitModel";
var KitIndexHeader = /** @class */ (function (_super) {
    __extends(KitIndexHeader, _super);
    function KitIndexHeader(props) {
        return _super.call(this, props) || this;
    }
    KitIndexHeader.prototype.render = function () {
        var imgPath;
        var altText;
        if (this.props.kit instanceof Ihc2Kit) {
            imgPath = proteinLogo;
            altText = 'Protein logo';
        }
        else {
            imgPath = rnaLogo;
            altText = 'RNA logo';
        }
        var productLabel;
        if (this.props.kit instanceof RnaFishKit) {
            if (this.props.kit.legacy) {
                productLabel = "(HCR™ RNA-FISH (v3.0))";
            }
            else {
                productLabel = "(HCR™ Gold RNA-FISH)";
            }
        }
        else if (this.props.kit instanceof Ihc2Kit) {
            if (this.props.kit.legacy) {
                productLabel = "(HCR™ IF)";
            }
            else {
                productLabel = "(HCR™ Gold IF)";
            }
        }
        else if (this.props.kit instanceof BundleOfKits) {
            productLabel = "(HCR™ Pro RNA-ISH)";
        }
        else {
            productLabel = "";
        }
        return React.createElement(Grid, { className: 'kit-index-header' },
            React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                    React.createElement(Header, { className: 'kit-num', title: this.props.title },
                        "Kit #",
                        this.props.itemIndex + 1,
                        " ",
                        productLabel)),
                ORIGIN === "mi" && React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                    React.createElement("img", { className: 'kit-index-logo', src: imgPath, alt: altText }))));
    };
    return KitIndexHeader;
}(React.PureComponent));
export default KitIndexHeader;
//# sourceMappingURL=KitIndexHeader.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/KitIndexHeader.js
// module id = 290
// module chunks = 0